import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { reactIcons } from "../../../utils/icons";

const YouTubeLinkModal = ({}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const data = localStorage.getItem("videoPlayEnable");
    if (data) {
      const parsedData = JSON.parse(data);
      const threeDaysInMs = 1 * 24 * 60 * 60 * 1000;

      if (Date.now() - parsedData.timestamp > threeDaysInMs) {
        localStorage.removeItem("videoPlayEnable");
        setOpen(true);
      }
    } else {
      setOpen(true);
    }
  }, []);

  const handleVideoPlay = () => {
    localStorage.setItem(
      "videoPlayEnable",
      JSON.stringify({ value: true, timestamp: Date.now() })
    );
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        scroll="paper"
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex: 9999,
          "& .MuiDialog-root": {
            zIndex: 9999
          },
          "& .MuiBackdrop-root": {
            zIndex: 9998
          },
          "& .MuiPaper-root": {
            background:
              "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)",
            border: "1px solid #69CEA6",
            zIndex: 10000
          }
        }}
      >
        <DialogContent dividers={true}>
          {" "}
          <div className="flex justify-between">
            <div className="text-xl font-bold text-white"></div>
            <button
              onClick={handleVideoPlay}
              className="flex h-5 w-[20px] items-center justify-center rounded-full border border-[#69CEA6] bg-white text-black"
            >
              {reactIcons.close}
            </button>
          </div>
          <div className="lg:text-xl text-center select-none text-sm mt-2 font-bold text-white">
            Please click on the below link or scan QR to like, share, and
            subscribe our channel.
          </div>
          <img
            className="bg-white p-2 mt-4 mx-auto select-none pointer-events-none"
            alt="Barcode Generator TEC-IT"
            src="/images/youtubeQr.gif"
          />
          <div
            className=" mt-3 text-center font-semibold select-none text-xl w-full cursor-pointer mb-3 text-blue-500 underline"
            onClick={() =>
              window.open(
                "https://youtube.com/@masterstroketec?si=GyVy3jHNWi1WD3Fl",
                "_blank"
              )
            }
          >
            Masterstroke Technosoft
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default YouTubeLinkModal;
